import React from 'react';

import { VerticalConfig } from 'utils/vertical';

const VerticalContext = React.createContext<VerticalConfig | null>(null);

export const useVerticalConfig = (): VerticalConfig => {
  const context = React.useContext(VerticalContext);

  if (context === null) {
    throw new ReferenceError('Vertical context is not defined');
  }

  return context;
};

export const VerticalProvider = VerticalContext.Provider;
